import {Component, Input} from '@angular/core';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-home-why-card-green',
  imports: [],
  templateUrl: './home-why-card-green.component.html',
})
export class HomeWhyCardGreenComponent {

  @Input()
  reduced = true
  protected readonly environment = environment;
}
